export const calculateExpiration = (sessionTimeout: number) => Date.now() + sessionTimeout * 1000 - 1000; //1 second before expected expiration
